import React from 'react';
import '../styles/VideoPage.css';

function Mission() {
  return (
    <div className="info-page">
      <div className="info-container">
        <div className="info-header">
          <h1> हमारा मिशन</h1>
        </div>
        <div className="info-content">
          <div className="info-section">
            <h2>लक्ष्य</h2>
            <p>
              हमारा मुख्य उद्देश्य चित्रकूट और आसपास के क्षेत्रों में सच्ची, निष्पक्ष और समय पर समाचार प्रदान करना है। हम विश्वास करते हैं कि सूचना ही शक्ति है और जनता को सही जानकारी मिलनी चाहिए।
            </p>
          </div>

          <div className="info-section">
            <h2>हमारा प्रतिबद्धता</h2>
            <ul className="info-list">
              <li>स्वतंत्र और निष्पक्ष पत्रकारिता</li>
              <li>समाज के सभी वर्गों की आवाज़ उठाना</li>
              <li>सच्चाई और पारदर्शिता में विश्वास</li>
              <li>लोकतांत्रिक मूल्यों को बनाए रखना</li>
              <li>समाज के विकास में योगदान</li>
            </ul>
          </div>

          <div className="info-section">
            <h2>हमारी ताकत</h2>
            <p>
              हमारी टीम के सदस्य अनुभवी पत्रकार हैं जो जनता की सेवा के लिए प्रतिबद्ध हैं। हम हर याचिका को गंभीरता से लेते हैं और उन की जांच-पड़ताल करते हैं।
            </p>
          </div>

          <div className="contact-info">
            <p>
              <strong>Email:</strong> info@latthsaab.com
            </p>
            <p>
              <strong>Phone:</strong> +91-9999-XXXXX
            </p>
            <p>
              <strong>📍 Address:</strong> चित्रकूट, उत्तर प्रदेश
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission;
